import { useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import { syncCcpaFromAccount } from "../../lib/privacyChoices";

// Applies a signed-in wolf's saved "Do Not Sell or Share" choice to this browser (analytics stays off).
export function PrivacySync() {
  const { user } = useAuth();
  const uid = user?.id;
  useEffect(() => { if (uid) syncCcpaFromAccount(); }, [uid]);
  return null;
}
